module.exports = __webpack_public_path__ + "img/Hotmart-1-es.5955988a.png";